// MobileFAB — rund floating-action-button i brand-navy för mobilens
// canvas-overlay (#38/#39, sub-plan Fas 8.4).
//
// Extraherad ur den duplicerade tools/properties-FAB-koden i
// MobileCanvasControls: 48px brand-navy-cirkel, vit ikon, shadow,
// `pointer-events-auto` (overlay-containern är pointer-events-none så
// canvas-gester går igenom mellan knapparna).
//
// Ren refactor — identisk renderad DOM mot de tidigare inlinade
// knapparna.

import type { ComponentType } from 'react';
import { Button } from '@/components/ui/button';
import { BRAND_NAVY } from '@/constants/brandColors';

interface MobileFABProps {
  /** Lucide-ikon (eller annan komponent som tar `className`). */
  icon: ComponentType<{ className?: string }>;
  onClick: () => void;
  /** Obligatorisk a11y-etikett — knappen har ingen synlig text. */
  ariaLabel: string;
}

export function MobileFAB({ icon: Icon, onClick, ariaLabel }: MobileFABProps) {
  return (
    <Button
      size="icon"
      className="rounded-full h-12 w-12 shadow-lg pointer-events-auto"
      style={{ backgroundColor: BRAND_NAVY }}
      onClick={onClick}
      aria-label={ariaLabel}
    >
      <Icon className="h-5 w-5 text-white" />
    </Button>
  );
}
